export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  coverImage: string;
  date: string;
  author: string;
  tags: string[];
  views: number;
  likes: number;
  content: string;
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: "1",
    slug: "2024-rixi-qingxin-xiezhen",
    title: "2024日系清新风美女写真精选 | 自然光影下的纯美瞬间",
    excerpt: "精选一组日系清新风格的美女写真作品，在自然光影中捕捉最纯真的美丽瞬间，带你感受日系摄影的独特魅力。",
    category: "meinv-xiezhen",
    categoryName: "美女写真",
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20style%20female%20portrait%20photography%20in%20natural%20sunlight%20with%20soft%20bokeh%20background%2C%20pastel%20tone%2C%20gentle%20expression%2C%20clean%20minimal%20composition%2C%20fashion%20editorial%20style%2C%20warm%20cream%20background&width=800&height=600&seq=article-cover-01&orientation=landscape",
    date: "2024-12-15",
    author: "编辑团队",
    tags: ["日系", "写真", "清新", "人像摄影"],
    views: 12800,
    likes: 986,
    featured: true,
    content: `<p>日系摄影以其清新自然的风格深受广大摄影爱好者和模特的喜爱。它不追求过度的修饰和夸张的表现，而是通过自然光线、柔和色调和真实的情感表达，捕捉人物最本真的美丽。</p>
<h2>日系清新风的魅力所在</h2>
<p>日系清新风写真最大的特点就是"自然感"。不同于商业摄影的精修和摆拍，这类作品更注重捕捉模特在自然环境中的真实状态。微风拂过发丝、阳光透过树叶洒落、不经意间的回眸一笑——这些看似平凡的瞬间，在优秀摄影师的镜头下却能展现出令人心动的美感。</p>
<p>光线运用是日系写真的核心。通常采用柔和的自然光，避免强烈的直射光和硬阴影。清晨和黄昏的黄金时段是拍摄的最佳时间，此时的光线温暖而柔和，能为画面增添一层梦幻般的质感。</p>
<h2>穿搭与场景的完美融合</h2>
<p>日系写真中的服装搭配以简约舒适为主，常见的有白色连衣裙、宽松毛衣、牛仔短裤等基础款单品。颜色方面偏向浅色系，如米白、淡粉、浅蓝等，与清新自然的场景相得益彰。</p>
<p>拍摄场景多选择在咖啡馆、花田、海边、老街等充满生活气息的地方。这些场景不仅为照片增添了故事感，也让观者感受到浓厚的生活美学。</p>
<h2>后期处理的克制之美</h2>
<p>日系风格的后期处理讲究"克制"，不过度磨皮、不过分调色。通常会略微提高曝光、降低对比度、增加一点点暖色调，让整体画面呈现出温柔通透的质感。</p>
<p>值得一提的是，这种风格对模特的表现力要求很高。不需要刻意摆pose，而是通过自然的动作和真实的情感流露来打动观众。</p>`,
  },
  {
    id: "2",
    slug: "dongji-shishang-chuanda-zhinan",
    title: "冬季时尚穿搭指南 | 保暖与美感兼得的搭配秘籍",
    excerpt: "寒冬来临，如何在保暖的同时保持时尚感？本文为你盘点今年冬季最流行的穿搭趋势和搭配技巧，让你温暖又时髦。",
    category: "shishang-chuanda",
    categoryName: "时尚穿搭",
    coverImage: "https://readdy.ai/api/search-image?query=Stylish%20winter%20fashion%20outfit%20with%20elegant%20woman%20wearing%20cozy%20coat%20and%20scarf%20in%20urban%20street%20scene%2C%20warm%20neutral%20tones%2C%20fashion%20editorial%20photography%2C%20clean%20composition&width=800&height=600&seq=article-cover-02&orientation=landscape",
    date: "2024-12-12",
    author: "时尚编辑",
    tags: ["冬季", "穿搭", "时尚", "保暖"],
    views: 9600,
    likes: 752,
    featured: true,
    content: `<p>冬季穿搭一直是时尚爱好者们面临的一大挑战——如何在层层包裹中依然保持时尚感？本文将为你详细解析今年冬季的流行趋势和实用搭配技巧。</p>
<h2>2024冬季流行趋势</h2>
<p>今年冬季， oversized 依然是主流。宽松的羊毛大衣、蓬松的羽绒服、oversized 毛衣都是热门单品。但与传统认知不同的是，今年的 oversized 更注重版型的精致感和面料的质感。</p>
<p>颜色方面，大地色系继续称霸冬季调色盘。焦糖色、奶茶色、驼色、深棕色都是不会出错的选择。如果想增添一些亮点，可以尝试酒红色或墨绿色作为点缀。</p>
<h2>层次感搭配法则</h2>
<p>冬季穿搭的精髓在于层次感。从内到外，每一层都有其功能性，同时也要兼顾整体的视觉效果。经典的三层穿法：贴身内搭 + 中间保暖层 + 外套，既保暖又不显臃肿。</p>
<h2>配饰的点睛之笔</h2>
<p>冬季配饰是提升整体造型的重要元素。一条质感好的围巾、一顶合适的帽子、一双精致的皮手套，都能让整体搭配更加出彩。今年特别流行的是针织帽和贝雷帽，既能保暖又能增添法式风情。</p>`,
  },
  {
    id: "3",
    slug: "chuji-meizhuang-jiaocheng",
    title: "新手友好！15分钟日常美妆教程 | 从零开始的化妆指南",
    excerpt: "化妆新手看过来！这篇详细的美妆教程从底妆到唇妆，手把手教你打造自然清新的日常妆容，15分钟轻松搞定。",
    category: "meizhuang-jiaocheng",
    categoryName: "美妆教程",
    coverImage: "https://readdy.ai/api/search-image?query=Beautiful%20woman%20applying%20makeup%20in%20front%20of%20vanity%20mirror%20with%20cosmetic%20products%20neatly%20arranged%2C%20soft%20warm%20lighting%2C%20elegant%20beauty%20scene%2C%20clean%20aesthetic%20photography&width=800&height=600&seq=article-cover-03&orientation=landscape",
    date: "2024-12-10",
    author: "美妆编辑",
    tags: ["美妆", "教程", "新手", "日常妆"],
    views: 15200,
    likes: 1234,
    featured: true,
    content: `<p>化妆对很多新手来说可能是一件令人望而生畏的事情。面对琳琅满目的化妆品和复杂的教程，不知道从何下手。别担心！这篇教程将带你从最基础的步骤开始，打造一个清新自然的日常妆容。</p>
<h2>妆前准备：护肤是基础</h2>
<p>好的妆容离不开好的皮肤基础。妆前护肤步骤不能省略：洁面 → 爽肤水 → 精华 → 乳液/面霜 → 防晒。每一步都要等产品充分吸收后再进行下一步，这样底妆才能服帖持久。</p>
<h2>底妆：打造清透好皮肤</h2>
<p>新手建议从气垫BB或轻薄的粉底液开始，用美妆蛋或粉底刷以点拍的方式均匀上妆。记住"少量多次"的原则，不要一次涂抹过多。遮瑕只需在需要的位置点涂即可，不要大面积使用。</p>
<h2>眉毛：自然毛流感是关键</h2>
<p>眉毛是面部轮廓的重要框架。新手建议使用眉粉而不是眉笔，更容易控制。顺着眉毛生长方向轻轻填充，眉头淡、眉尾深，打造自然渐变效果。</p>
<h2>眼妆与唇妆：点睛之笔</h2>
<p>日常妆的眼妆不需要太复杂。浅棕色眼影打底，深棕色在眼尾加深，画一条细细的眼线，刷上睫毛膏就足够了。唇妆选择豆沙色或奶茶色，自然提气色。</p>`,
  },
  {
    id: "4",
    slug: "gaoyanzhi-shenghuo-blogger",
    title: "5位高颜值生活方式博主推荐 | 提升生活品质的灵感源泉",
    excerpt: "为你推荐5位高质量生活方式博主，从家居美学到健身美食，她们用独特视角诠释精致生活的无限可能。",
    category: "bozhu-tuijian",
    categoryName: "博主推荐",
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20female%20lifestyle%20blogger%20creating%20content%20in%20beautifully%20decorated%20home%20with%20warm%20natural%20light%2C%20minimalist%20aesthetic%2C%20cozy%20atmosphere%2C%20lifestyle%20photography&width=800&height=600&seq=article-cover-04&orientation=landscape",
    date: "2024-12-08",
    author: "编辑部",
    tags: ["博主", "生活方式", "推荐", "高颜值"],
    views: 8700,
    likes: 645,
    featured: false,
    content: `<p>在信息爆炸的时代，找到真正优质的内容创作者并不容易。今天，我们为你精心挑选了5位值得关注的高颜值生活方式博主，她们用独特的视角和专业的内容，为我们的生活带来无限灵感。</p>
<h2>博主一：@小雨生活志</h2>
<p>小雨是一位家居美学博主，她的内容涵盖了家居布置、收纳整理和日常Vlog。她的家充满了温暖的生活气息，每一帧画面都像电影般美好。特别推荐她的"周末慢生活"系列，让人在快节奏的城市生活中找到片刻宁静。</p>
<h2>博主二：@健身小仙女的日常</h2>
<p>这位博主以科学健身和健康饮食内容著称。她不是那种"要么瘦要么死"的极端健身博主，而是倡导健康、可持续的生活方式。她的食谱视频简单易学，特别适合忙碌的都市女性。</p>`,
  },
  {
    id: "5",
    slug: "hanxi-weimei-xiezhen",
    title: "韩系唯美写真图集 | 温柔色调下的浪漫瞬间",
    excerpt: "韩系写真以其唯美的色调和细腻的情感表达著称，这组精选图集带你领略韩式摄影的浪漫与温柔。",
    category: "xiezhen-tuji",
    categoryName: "写真图集",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20style%20romantic%20female%20portrait%20photography%20with%20soft%20pastel%20tones%2C%20elegant%20woman%20in%20flowing%20dress%2C%20dreamy%20bokeh%20background%2C%20gentle%20expression%2C%20editorial%20fashion%20photography&width=800&height=600&seq=article-cover-05&orientation=landscape",
    date: "2024-12-05",
    author: "摄影编辑",
    tags: ["韩系", "写真", "唯美", "浪漫"],
    views: 11300,
    likes: 892,
    featured: true,
    content: `<p>韩系写真在国内一直有着极高的人气。它融合了韩剧般的浪漫情怀和精致的美学追求，创造出了独特的视觉风格。今天，我们就来欣赏一组精选的韩系唯美写真作品。</p>
<h2>韩系写真的视觉特点</h2>
<p>韩系写真最突出的特点就是色调的运用。温暖的米色调、柔和的粉色系、清新的薄荷绿，这些颜色在韩系写真中频繁出现，营造出一种梦幻而治愈的视觉体验。与日系写真相比，韩系风格在色彩上更加丰富和饱和，但依然保持了温柔的特质。</p>
<h2>取景与构图的巧思</h2>
<p>韩系写真在场景选择上很有讲究。咖啡馆、花店、书店、天台——这些充满文艺气息的场所是韩系摄影师的最爱。构图上偏爱浅景深，将焦点集中在模特的面部表情上，背景虚化成梦幻的光斑。</p>
<h2>模特的情绪表达</h2>
<p>韩系写真非常注重模特的情感表达。不同于欧美写真的张扬和自信，韩系风格更偏爱含蓄、温柔、略带忧郁的气质。一个低头的微笑、一个若有所思的眼神，都能成为画面的点睛之笔。</p>`,
  },
  {
    id: "6",
    slug: "chunji-shishang-dapei",
    title: "春季时尚搭配灵感 | 轻盈色彩与层次感的完美平衡",
    excerpt: "春天来了，衣橱也该焕新啦！从色彩搭配到单品选择，为你整理春季最实用的穿搭灵感。",
    category: "shishang-chuanda",
    categoryName: "时尚穿搭",
    coverImage: "https://readdy.ai/api/search-image?query=Spring%20fashion%20outfit%20with%20elegant%20woman%20wearing%20light%20floral%20dress%20in%20blooming%20garden%2C%20soft%20pastel%20colors%2C%20fresh%20spring%20atmosphere%2C%20fashion%20editorial%20photography&width=800&height=600&seq=article-cover-06&orientation=landscape",
    date: "2024-12-03",
    author: "时尚编辑",
    tags: ["春季", "穿搭", "色彩", "搭配"],
    views: 7800,
    likes: 567,
    featured: false,
    content: `<p>告别厚重的冬装，春天是展现轻盈与活力的最佳季节。今年的春季时尚有着丰富的色彩选择和层次搭配可能，让我们一起来看看。</p>
<h2>2025春季流行色</h2>
<p>今年春季的流行色以柔和明亮的浅色系为主。薰衣草紫、奶油黄、薄荷绿、珊瑚粉都是热门色号。特别是薰衣草紫，从T台到街头，成为了当之无愧的季节主打色。</p>
<h2>层次搭配技巧</h2>
<p>春季温差大，层次搭配尤为重要。轻薄风衣、针织开衫、牛仔外套都是春季必备单品。内搭选择简约的T恤或衬衫，热了可以脱掉外套，冷了又能保暖。</p>`,
  },
  {
    id: "7",
    slug: "zhuanYe-jiemei-hufu",
    title: "专业级护肤流程全解析 | 打造水光肌的早晚护肤步骤",
    excerpt: "想要拥有韩剧女主般的水光肌？这篇护肤全攻略从清洁到精华，为你拆解早晚护肤的正确步骤和产品选择。",
    category: "meizhuang-jiaocheng",
    categoryName: "美妆教程",
    coverImage: "https://readdy.ai/api/search-image?query=Skincare%20routine%20with%20beautiful%20woman%20applying%20serum%20in%20bright%20bathroom%2C%20glass%20skin%20glow%2C%20clean%20minimal%20aesthetic%2C%20beauty%20product%20flatlay%2C%20soft%20natural%20lighting&width=800&height=600&seq=article-cover-07&orientation=landscape",
    date: "2024-12-01",
    author: "护肤达人",
    tags: ["护肤", "水光肌", "流程", "美白"],
    views: 18600,
    likes: 1520,
    featured: true,
    content: `<p>好皮肤是美女的第一资本。与其花大价钱买遮瑕产品，不如从根源上把皮肤养好。今天就为大家详细拆解早晚护肤的正确流程。</p>
<h2>早间护肤：防护为主</h2>
<p>早晨的护肤重点是防护和保湿。步骤相对简单：温和洁面 → 爽肤水 → 精华 → 眼霜 → 乳液 → 防晒。防晒是早间护肤最重要的一步，无论晴天阴天都不能省略。</p>
<h2>晚间护肤：修护为核</h2>
<p>晚上是皮肤修复的黄金时间。步骤会更加丰富：卸妆 → 洁面 → 去角质（每周1-2次）→ 爽肤水 → 面膜（每周2-3次）→ 精华 → 眼霜 → 晚霜。每一步都要给皮肤足够的时间吸收。</p>`,
  },
  {
    id: "8",
    slug: "jiankang-jianshen-ridai",
    title: "都市女性的健康健身日常 | 不节食也能拥有好身材",
    excerpt: "告别极端节食和过度运动，分享科学健康的健身方法和饮食建议，让你在享受生活的同时保持好身材。",
    category: "shenghuo-fangshi",
    categoryName: "生活方式",
    coverImage: "https://readdy.ai/api/search-image?query=Fit%20woman%20doing%20yoga%20in%20bright%20modern%20studio%20with%20large%20windows%20and%20natural%20light%2C%20healthy%20lifestyle%2C%20athletic%20elegant%20style%2C%20wellness%20photography&width=800&height=600&seq=article-cover-08&orientation=landscape",
    date: "2024-11-28",
    author: "健康编辑",
    tags: ["健身", "健康", "饮食", "塑形"],
    views: 6500,
    likes: 478,
    featured: false,
    content: `<p>很多女性为了身材不惜节食甚至断食，这是非常不健康的方式。真正的好身材来源于科学运动和合理饮食的长期坚持。</p>
<h2>科学运动方案</h2>
<p>每周3-4次运动，每次45-60分钟是最理想的频率。建议将有氧运动和力量训练结合起来：有氧燃脂，力量塑形。瑜伽和普拉提也是非常好的选择，能改善体态和柔韧性。</p>
<h2>合理饮食原则</h2>
<p>与其节食，不如学会"聪明地吃"。保证足够的蛋白质摄入，选择复合碳水，多吃蔬菜水果，适量健康脂肪。偶尔的放纵餐也是可以的，不要给自己太大压力。</p>`,
  },
  {
    id: "9",
    slug: "guofeng-guyun-xiezhen",
    title: "国风古韵写真精选 | 东方美学的诗意呈现",
    excerpt: "汉服、旗袍、古风场景，这组国风写真将东方女性的古典美展现得淋漓尽致，带你穿越时空感受千年风雅。",
    category: "xiezhen-tuji",
    categoryName: "写真图集",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20traditional%20hanfu%20style%20female%20portrait%20in%20ancient%20garden%20with%20cherry%20blossoms%2C%20elegant%20classical%20beauty%2C%20soft%20golden%20light%2C%20traditional%20Chinese%20aesthetic%20photography&width=800&height=600&seq=article-cover-09&orientation=landscape",
    date: "2024-11-25",
    author: "文化编辑",
    tags: ["国风", "汉服", "古韵", "东方美"],
    views: 14200,
    likes: 1156,
    featured: true,
    content: `<p>近年来，国风文化持续走热，越来越多的年轻人开始关注和喜爱中国传统文化。国风写真作为传统文化与现代摄影的结合，也受到了广泛追捧。</p>
<h2>国风写真的独特魅力</h2>
<p>国风写真不同于现代时尚写真，它追求的是一种穿越时空的古典美感。汉服的飘逸、旗袍的优雅、古建筑的大气，共同构成了一幅幅如诗如画的视觉作品。</p>
<h2>服饰与发型的讲究</h2>
<p>一套成功的国风写真离不开精致的服饰和发型。从汉服的形制选择到头饰的搭配，从妆容的古风还原到发型的历史考据，每一个细节都关乎最终呈现的效果。</p>`,
  },
  {
    id: "10",
    slug: "xiaohongshu-bozhu-tuijian",
    title: "小红书最值得关注的10位时尚美妆博主",
    excerpt: "盘点小红书平台上最受欢迎的时尚美妆博主，从穿搭到护肤，从平价到高端，总有一位适合你。",
    category: "bozhu-tuijian",
    categoryName: "博主推荐",
    coverImage: "https://readdy.ai/api/search-image?query=Fashion%20beauty%20influencer%20creating%20content%20with%20smartphone%20in%20trendy%20apartment%2C%20modern%20minimalist%20decor%2C%20lifestyle%20blogger%20aesthetic%2C%20warm%20neutral%20lighting&width=800&height=600&seq=article-cover-10&orientation=landscape",
    date: "2024-11-22",
    author: "编辑部",
    tags: ["小红书", "博主", "推荐", "时尚"],
    views: 10500,
    likes: 834,
    featured: false,
    content: `<p>小红书已经成为时尚美妆内容的重要阵地。这里聚集了大量优质的内容创作者，从专业化妆师到时尚买手，各有特色。</p>
<h2>挑选优质博主的技巧</h2>
<p>关注博主不要只看粉丝量，更要看内容质量和真实性。好的博主会分享真实的使用体验，而不是一味吹捧产品。同时也要注意博主的审美是否与自己的风格相符。</p>`,
  },
  {
    id: "11",
    slug: "xiari-qingliang-chuanda",
    title: "夏日清凉穿搭合集 | 炎热天气也能时髦出街",
    excerpt: "炎炎夏日如何穿得清凉又时尚？从面料选择到款式搭配，为你整理最实用的夏季穿搭攻略。",
    category: "shishang-chuanda",
    categoryName: "时尚穿搭",
    coverImage: "https://readdy.ai/api/search-image?query=Summer%20fashion%20with%20beautiful%20woman%20wearing%20light%20airy%20outfit%20on%20sunny%20beach%20boardwalk%2C%20fresh%20breezy%20style%2C%20vacation%20vibes%2C%20fashion%20editorial&width=800&height=600&seq=article-cover-11&orientation=landscape",
    date: "2024-11-20",
    author: "时尚编辑",
    tags: ["夏季", "清凉", "穿搭", "度假"],
    views: 9200,
    likes: 703,
    featured: false,
    content: `<p>夏天穿衣服最大的困扰就是——热！但炎热不能成为放弃时尚的理由。掌握以下技巧，让你清凉又时髦。</p>
<h2>面料选择有讲究</h2>
<p>夏季首选天然面料：纯棉、亚麻、真丝、莫代尔都是不错的选择。这些面料透气性好，穿着舒适。避免选择化纤面料，虽然便宜但闷热不透气。</p>
<h2>款式搭配技巧</h2>
<p>宽松版型是夏季穿搭的关键词。阔腿裤、A字裙、oversized T恤都能让空气流通，带来清凉感。颜色选择浅色系，能反射阳光，视觉上也更加清爽。</p>`,
  },
  {
    id: "12",
    slug: "wanmei-dizhuang-jiaocheng",
    title: "完美底妆教程 | 告别卡粉浮粉，打造零瑕疵底妆",
    excerpt: "底妆是整个妆容的基础，底妆不好全脸白费。这篇教程教你如何选对产品、用对方法，打造持久完美的底妆。",
    category: "meizhuang-jiaocheng",
    categoryName: "美妆教程",
    coverImage: "https://readdy.ai/api/search-image?query=Flawless%20foundation%20application%20on%20beautiful%20woman%20face%20closeup%2C%20dewy%20skin%20texture%2C%20makeup%20artist%20at%20work%2C%20professional%20beauty%20photography%2C%20soft%20studio%20lighting&width=800&height=600&seq=article-cover-12&orientation=landscape",
    date: "2024-11-18",
    author: "美妆达人",
    tags: ["底妆", "粉底", "教程", "遮瑕"],
    views: 13400,
    likes: 1098,
    featured: false,
    content: `<p>底妆是妆容的根基。一个完美的底妆能让后续的妆容事半功倍。今天就来看看如何打造服帖、持久、自然的底妆。</p>
<h2>妆前打底不可少</h2>
<p>很多人跳过妆前这一步直接上粉底，这是底妆不服帖的主要原因。根据自己的肤质选择合适的妆前乳：干皮选保湿型，油皮选控油型，毛孔粗大选填毛孔型。</p>
<h2>粉底的选择与上妆手法</h2>
<p>选对色号是底妆成功的一半。试色时应该在脸颊和脖子交界处测试，选择与肤色最接近的色号。上妆时用湿润的美妆蛋以拍弹的方式从面部中央向外推开。</p>`,
  },
];

export const articlesBySlug: Record<string, Article> = {};
articles.forEach((article) => {
  articlesBySlug[article.slug] = article;
});

export const articlesByCategory: Record<string, Article[]> = {};
articles.forEach((article) => {
  if (!articlesByCategory[article.category]) {
    articlesByCategory[article.category] = [];
  }
  articlesByCategory[article.category].push(article);
});

export const featuredArticles = articles.filter((a) => a.featured);

export const latestArticles = [...articles].sort(
  (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
);